import { useEffect, useState } from 'react'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { lerVisto, listarAlertas } from '../api/alertas'
import { useAuth } from '../state/AuthContext'
import { Hicon } from './Hicon'

/** Sino do topo: quantos alertas dos últimos 7 dias chegaram desde a última visita à página. */
export function SinoAlertas() {
  const { pode } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [novos, setNovos] = useState(0)
  const [criticos, setCriticos] = useState(0)
  const veAlertas = pode('paineis.ver')

  useEffect(() => {
    if (!veAlertas) return
    let cancelado = false
    const contar = () =>
      listarAlertas(null, 7)
        .then((lista) => {
          if (cancelado) return
          const visto = lerVisto()
          const n = lista.filter((a) => a.geradoEm > visto)
          setNovos(n.length)
          setCriticos(n.filter((a) => a.severidade === 'critico').length)
        })
        .catch(() => {})
    contar()
    const t = setInterval(contar, 10 * 60_000)
    return () => {
      cancelado = true
      clearInterval(t)
    }
  }, [veAlertas, pathname])

  if (!veAlertas) return null
  return (
    <Tooltip title={novos ? `${novos} ${novos === 1 ? 'alerta novo' : 'alertas novos'}${criticos ? `, ${criticos} crítico(s)` : ''}` : 'Alertas'}>
      <IconButton aria-label="Alertas" onClick={() => navigate('/alertas')} sx={{ p: 0.75 }}>
        <Badge badgeContent={novos} color={criticos ? 'error' : 'warning'} max={99}>
          <Hicon name="bell" sx={{ fontSize: '1.375rem' }} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}
